import { motion } from 'framer-motion'
import React, { useState } from 'react'
import NavLink from '../molecules/NavLink'

const MobileNavLink = ({ id, target, emphasize, subNav }) => {
  const [isOpen, setOpen] = useState(false)

  return (
    <li
      key={id}
      className="py-5 border-b border-gray-4 last:border-0 text-[15px] font-bold"
    >
      {subNav.length > 0 ? (
        <>
          <button
            type="button"
            className="text-[15px] font-bold flex items-center justify-between w-full"
            onClick={() => setOpen(!isOpen)}
          >
            <NavLink target={target} emphasize={emphasize} />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="7"
              fill="none"
              viewBox="0 0 11 7"
              className={`transition-transform transform ${
                isOpen ? 'rotate-180' : ''
              }`}
            >
              <path
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="2"
                d="M1 1l4.5 4.5L10 1"
              ></path>
            </svg>
          </button>
          <div className="overflow-hidden">
            <motion.div
              className="flex flex-col pl-4.5 space-y-5 overflow-hidden"
              animate={{ height: isOpen ? 'auto' : 0 }}
              transition={{ type: 'ease' }}
            >
              {subNav.map(({ id: childId, target: childTarget }, index) => (
                <div className={`${index === 0 && 'pt-7'}`} key={childId}>
                  <NavLink target={childTarget} />
                </div>
              ))}
            </motion.div>
          </div>
        </>
      ) : (
        <NavLink target={target} emphasize={emphasize} />
      )}
    </li>
  )
}

export default MobileNavLink
